import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPreparedSelectedEmojiSecondary from './svgs/PreparedSelectedEmojiSecondary.js';
import SvgPreparedSelectedEmoji from './svgs/PreparedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var preparedSelectedEmoji = (props => useIcon(SvgPreparedSelectedEmoji, SvgPreparedSelectedEmojiSecondary, props));

export { preparedSelectedEmoji as default };
